import PermissionContext from "../../Context/PermissionContext";
import AppContainer from "../Structure/AppContainer";
import React, { useContext } from "react";

const PermissionsDistribution = () => {
  const { permissionList } = useContext(PermissionContext);

  return (
    <AppContainer title="Permissions Distribution">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card pb-0">
              <table className="table table-striped table-hover table-responsive">
                <thead style={{ backgroundColor: "#022151ff", color: "white" }}>
                  <tr>
                    <th style={{ color: "white" }}>#</th>
                    <th style={{ color: "white" }}>Permission Code</th>
                    <th style={{ color: "white" }}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {permissionList && permissionList.length > 0 ? (
                    permissionList.map((perm, index) => (
                      <tr key={perm.permission_id}>
                        <td>{index + 1}</td>
                        <td>{perm.permission_code}</td>
                        <td>{perm.permission_description}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center py-3">
                        No permissions found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};

export default PermissionsDistribution;
